import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import {
  BudgetImportReasoningEffort,
  BudgetImportResult,
  BudgetSlotSchema,
} from '../../components/question/budget/budget-import/budget-import.interface';

/**
 * Override in the consuming app (see BaseFileService). The default hides the import feature.
 */
@Injectable({
  providedIn: 'root',
})
export class BaseBudgetImportService {
  public isSupported(): boolean {
    return false;
  }

  public importBudget(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    file: File,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    schema: BudgetSlotSchema,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    reasoningEffort?: BudgetImportReasoningEffort,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    deployment?: string,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    preprocessing?: boolean,
  ): Observable<BudgetImportResult> {
    return throwError(
      () => new Error('BaseBudgetImportService has not been implemented'),
    );
  }
}
